<template>
  <div class="list-view" v-if="finishedLoading">
    <!-- INICIO MODAL -->
    <Modal
      v-if="showModal"
      @close="(alterado)=>voltar(alterado)"
      :solicitacaoProps="solicitacao"
      :investidor="currentUser.investor"
      :usuario="currentUser"
      :valorInicial="selected"
      :reservaInvestimento="investmentReservation"
    />
    <!-- TERMINO MODAL -->

    <!-- PERFIL DA EMPRESA -->
    <div class="row company-view" :class="scoreClass" v-if="solicitacao != null">
    	<div class="col-12">

			<!--  CABECALHO -->
			<div class="row tit_page">
				<div class="col-12">
					<div class="float-left">
						<h1>Oportunidade <span>id#{{id}}</span></h1>
					</div>
					<div class="back float-right">
						<router-link :to="'/investimentos/oportunidades'+voltarLink()" title="Voltar"><i>&nbsp;</i> voltar</router-link>
					</div>
					<div class="clearfix"></div>
					<hr class="divider">
				</div>
			</div>
			<!-- :::::::::::::::: -->

        <!-- CORPO -->
        <div class="row">

          <!-- DADOS DO PERFIL DA EMPRESA -->
          <div class="col-12 col-md-8 col-lg-8">
            <!-- INFORMACOES INCIAIS DA EMPRESA -->
            <div class="tit">
              <div class="float-left">
                <h2>{{nomeFantasia}}</h2>
                <span>CNPJ: {{formattedCnpj}}</span>
                <small>{{formatarTipoEmprestimo(loanType)}}</small>
              </div>
              <div class="rating float-left float-md-right">
                <strong>
                  Score da operação
                  <span class="circle score"></span> 
                  {{score}}
                </strong>
              </div>
              <div class="clearfix"></div>
            </div>
            <!-- ::::::::::::::::::::::::: -->

            <!-- IMAGEMS E DESCRICAO DA EMPRESA -->
            <section>
              <at-tabs>
                <at-tab-pane label="Fotos" name="name1" icon="icon-camera">
                  <carousel :pictures="pictures" />
                </at-tab-pane>
                <at-tab-pane label="Vídeo" name="name2" icon="icon-video" v-if="vimeoVideoUrl !== ''">
                  <div class="row">
                    <div class="col-12">
                      <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" :src="vimeoVideoUrl" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
                      </div>
                    </div>
                  </div>
                </at-tab-pane>
              </at-tabs>
              <div>

              </div>
              <h4 style="margin-top: 30px;">Descrição breve sobre a empresa</h4>
              <div v-html="companyDescription"></div>
            </section>
            <!-- :::::::::::::::::::::::::: -->


            <!-- DADOS DA EMPRESA -->
            <section>
              <h3>Dados da empresa</h3>

              <div class="row">

                <div class="col-12 col-lg-6">
                  <label>Empresa
                    <span>(Razão social)</span>
                  </label>
                  <span>{{razaoSocial}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>CPF/CNPJ</label>
                  <span>{{formattedCnpj}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>Nome do responsável</label>
                  <span>{{nomeSolicitante}}</span>
                </div>
                <div class="col-12 col-lg-6">
                  <label>Nome fantasia</label>
                  <span>{{nomeFantasia}}</span>
                </div>
                <div class="col-12 col-lg-6">
                  <label>Telefone comercial</label>
                  <span>{{telefoneComercial}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>Data de fundação</label>
                  <span>{{dataFundacao}}</span>
                </div>
                <div class="col-12 col-lg-3">
                  <label>Número de funcionários</label>
                  <span>{{quantidadeEmpregados}} empregados</span>
                </div>
                <div class="col-12 col-lg-6" v-if="nomeGrupoEconomico">
                  <label>Nome do grupo ecônomico</label>
                  <span>{{nomeGrupoEconomico}}</span>
                </div>
                <div class="col-12">
                  <label>Endereço</label>
                  <span>{{address}}</span>
                </div>
                <div class="col-12 col-lg-5" v-if="site">
                  <label>Site</label>
                  <span>{{site}}</span>
                </div>
                <div class="col-12 col-lg-7" v-if="companyFacebook || companyTwitter || companyLinkedin || companyInstagram || companyVimeo">
                  <label>Redes Sociais</label>
                  <span>
                    <a v-if="companyFacebook" :href="companyFacebook" class="fab fa-facebook-square"></a>
                    <a v-if="companyTwitter" :href="companyTwitter" class="fab fa-twitter"></a>
                    <a v-if="companyLinkedin" :href="companyLinkedin" class="fab fa-linkedin-in"></a>
                    <a v-if="companyInstagram" :href="companyInstagram" class="fab fa-instagram"></a>
                    <a v-if="companyVimeo" :href="companyVimeo" class="fab fa-vimeo-v"></a>
                  </span>
                </div>

                <div class="col-12" v-if="formatoInvestimento">
                  <div class="alert alert-secondary" role="alert">
                    <strong>Formato do Investimento:</strong> {{formatoInvestimento}}
                  </div>
                </div>
              </div>


              <!-- LOCALIZACAO -->
              <iframe :src="mapUrl" width="100%" height="280" frameborder="0" style="border:0; border-radius:5px;" allowfullscreen></iframe>
              <!-- ::::::::::::: -->

              <div>
                <h4>Motivo da solicitação do empréstimo</h4>
                <p>{{motivoSolicitacao}}</p>
              </div>

              <div>
                
                <h4>Garantias oferecidas</h4>
                <img src="/static/assets/images/selo-garantia-bndes.png" class="selo-garantia" title="Oportunidade com garantia pelo tomador e indicada pelo canal BNDES" v-if="id == 22647">
                <p>{{garantiasOferecidas}}</p>
              </div>

            </section>
            <!-- :::::::::::::::::::::: -->

            <!-- ANALISE -->
            <section>

              <h3>Análise sobre a empresa</h3>
              <div class="em-analise" v-if="showMeInfo()" v-html="analiseEmpresa"></div>

            </section>
            <!-- ::::::::::::::: -->
          </div>
          <!-- :::::::::::::::::::::: -->

          <!-- FORM DE INVESTIMENTO -->
          <aside class="col-12 col-md-4 col-lg-4">
            <investment-reservation-form ref="investForm" :loan-request="solicitacao" :investment-confirmed="this.investmentConfirmed"
              @submit="submitInvestment" />
          </aside>
          <!-- ::::::::::::::::::: -->


          <!-- INICIO BLOGO DE INDICES -->
					<div class="col-12 indices" v-if="showMeInfo()">
						<div class="divider-block"></div>

						<!-- INICIO TIPO EMPRESA -->
						<section class="row indices__tipo">
							<div class="col-12 col-md-12 col-lg-4">
								<div class="porte">
									<label>Porte da empresa</label>
									<p>{{porteEmpresa}}</p>
								</div>
							</div>

							<div class="col-12 col-md-12 col-lg-8 indices__tipo-setor" v-if="validacaoSetor(this.solicitacao.Empresa)">
								<div class="row no-gutters">
									<div class="col-12 col-md-4 col-lg-3 setor">
										<label>Setor da empresa</label>
										<p>{{Setor}}</p>
									</div>
									<div class="col-12 col-md-8 col-lg-9 risco">
										<label>Risco de crédito do setor*</label>
										<div class="row row no-gutters">
											<div class="col-12 col-md-6 col-lg-5">
												<p>Pontuação do setor:
													<strong>{{PontuacaoSetor}}</strong>
												</p>
											</div>
											<div class="col-12 col-md-7 col-lg-7">
												<p>Prob. Média de Inadimplência:
													<strong>{{InadimplenciaSetor}}%</strong>
												</p>
											</div>
										</div>
									</div>
								</div>
								<p class="small">* A probabilidade média associada a classe de risco de crédito para esse segmento é de: {{InadimplenciaSetor}}%. Para cada 100 empresas
									situadas na mesma classe de risco de crédito desse segmento, {{InadimplenciaSetor}} poderão apresentar um dos eventos que caracterizam
									inadimplência para o modelo.</p>
							</div>
						</section>
						<!-- FINAL TIPO EMPRESA -->

						<!-- LINKS LINKS NAV -->
						<nav>
							<div class="nav nav-tabs" id="nav-tab" role="tablist">
								<a class="nav-item nav-link active" id="ind-fin-tab" data-toggle="tab" href="#nav-indf" role="tab" aria-controls="nav-indf" aria-selected="true">Índices financeiros</a>
								<a class="nav-item nav-link" id="ind-cont-tab" data-toggle="tab" href="#nav-indc" role="tab" aria-controls="nav-indc" aria-selected="false" v-if="verificaValoresIndices(this.solicitacao.Empresa.IndicesFinanceiros)">Índices complementares</a>
								<a class="nav-item nav-link" id="inf-socios-tab" data-toggle="tab" href="#nav-info" role="tab" aria-controls="nav-info" aria-selected="false" v-if="this.solicitacao.Empresa.Socios && this.solicitacao.Empresa.Socios.length > 0">Informações sobre sócios</a>
							</div>
						</nav>
						<!-- FINAL LINKS NAV -->

						<!-- INICIO CONTEUDO TABS -->
						<div class="tab-content" id="nav-tabContent">
							<!-- INICIO INDICES FINANCEIROS -->
							<div class="tab-pane fade show active" id="nav-indf" role="tabpanel" aria-labelledby="ind-fin-tab">
								<section class="indices__financeiros">
									<div class="row indices__financeiros--valores">

                    <!-- VALORES -->
										<div class="col-12 col-md-12 col-lg-4">
											<div class="row">
												<div class="col-12 col-md-6">
													<div class="box">
														<label>Faturamento anual</label>
														<p>R$ {{faturamentoAnual}}</p>
													</div>
												</div>
												<div class="col-12 col-md-6">
													<div class="box">
														<label>Lucro líquido mensal</label>
														<p>R$ {{lucroLiquido}}</p>
													</div>
												</div>
											</div>
										</div>
                    <!-- :::::::::::: -->

                    <!-- VALORES -->
										<div class="col-12 col-md-12 col-lg-8">
											<div class="row">
												<div class="col-12 col-md-6 col-lg-6">
													<div class="box">
														<div class="row no-gutters">
															<div class="col-12 col-md-6">
																<label>Endividamento</label>
																<p>{{divida}}</p>
															</div>
															<div class="col-12 col-md-6">
																<label>Data base da consulta</label>
																<p>{{dataConsultaEndividamento}}</p>
															</div>
														</div>
													</div>
												</div>
												<div class="col-12 col-md-6 col-lg-6">
													<div class="box">
														<div class="row no-gutters">
															<div class="col-12 col-md-6">
																<label>Negativações</label>
																<p>{{negativacoes}}</p>
															</div>
															<div class="col-12 col-md-6">
																<label>Atrasos/restritivos
																	<span>(90 dias)</span>
																</label>
																<p>R$ {{atrasos}}</p>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
                    <!-- ::::::::::::: -->

                    <!-- GRAFICO DO FATURAMENTO -->
										<div class="col-12 col-lg-12">
											<div class="box box_chart">
												<h2>Faturamento dos últimos 12 meses</h2>
												<bar-chart :data="chartData" />
											</div>
										</div>
                    <!-- ::::::::::: -->

                    <!-- ANALISE VERTICAL -->
										<div class="col-12 col-lg-12" v-if=" verificaValoresVertical(this.solicitacao.Empresa.Balancos)">
											<div class="box box_chart">
												<h2>
                          Análise vertical
                          <at-popover trigger="hover" placement="right" content="A Análise Vertical (AV) é também conhecida como Análise de Estrutura, é utilizado para identificar a porcentagem de participação de determinado indicador no resultado, permitindo que sejam feitas comparações caso existam dois ou mais períodos.">
                            <i class="fas fa-info-circle"></i>
                          </at-popover>
                        </h2>

												<div class="row">
													<div class="col-12 col-md-6">
														<div class="box box_chart text-center" style="margin-bottom:20px;">
															<h4 v-if="this.solicitacao.Empresa.Mes1 == '' || this.solicitacao.Empresa.Mes1 == undefined">{{this.solicitacao.Empresa.Ano1}}</h4>
                              <h4 v-else>{{this.solicitacao.Empresa.Mes1}}/{{this.solicitacao.Empresa.Ano1}}</h4>
															<div class="box_chart-row">
																<div class="box_chart-col col-one">
                                  <!-- ATIVO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano1.AtivoCirculante)"><span class="rounded-circle">{{Balanco.ano1.AtivoCirculante}}%</span></div>
                                  <!-- ::::::::::::: -->
                                  <!-- ATIVO NA CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano1.AtivoNCirculante)"><span class="rounded-circle">{{Balanco.ano1.AtivoNCirculante}}%</span></div>
                                  <!-- :::::::::::::::: -->
																</div>
																<div class="box_chart-col col-two">
                                  <!-- PASSICO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano1.PassivoCirculante)"><span class="rounded-circle">{{Balanco.ano1.PassivoCirculante}}%</span></div>
                                  <!-- ::::::::::: -->
                                  <!-- PASSIVO NAO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano1.PassivoNCirculante)"><span class="rounded-circle">{{Balanco.ano1.PassivoNCirculante}}%</span></div>
                                  <!-- :::::::::::::::: -->
                                  <!-- PATRIMONIO LIQUIDO -->
																	<div :style="blockHight(Balanco.ano1.PatrimonioLiquido)"><span class="rounded-circle">{{Balanco.ano1.PatrimonioLiquido}}%</span></div>
                                  <!-- ::::::::::::::: -->
																</div>
															</div>
														</div>
													</div>
													<div class="col-12 col-md-6">
														<div class="box box_chart text-center" style="margin-bottom:20px;">
															<h4 v-if="this.solicitacao.Empresa.Mes2 == '' || this.solicitacao.Empresa.Mes2 == undefined">{{this.solicitacao.Empresa.Ano2}}</h4>
                              <h4 v-else>{{this.solicitacao.Empresa.Mes2}}/{{this.solicitacao.Empresa.Ano2}}</h4>
															<div class="box_chart-row">
																<div class="box_chart-col col-one">
                                  <!-- ATIVO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano2.AtivoCirculante)"><span class="rounded-circle">{{Balanco.ano2.AtivoCirculante}}%</span></div>
                                  <!-- ::::::::::::: -->
                                  <!-- ATIVO NAO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano2.AtivoNCirculante)"><span class="rounded-circle">{{Balanco.ano2.AtivoNCirculante}}%</span></div>
                                  <!-- ::::::::::::::: -->
																</div>
																<div class="box_chart-col col-two">
                                  <!-- PASSICO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano2.PassivoCirculante)"><span class="rounded-circle">{{Balanco.ano2.PassivoCirculante}}%</span></div>
                                  <!-- ::::::::::: -->
                                  <!-- PASSIVO NAO CIRCULANTE -->
																	<div :style="blockHight(Balanco.ano2.PassivoNCirculante)"><span class="rounded-circle">{{Balanco.ano2.PassivoNCirculante}}%</span></div>
                                  <!-- :::::::::::::::: -->
                                  <!-- PATRIMONIO LIQUIDO -->
																	<div :style="blockHight(Balanco.ano2.PatrimonioLiquido)"><span class="rounded-circle">{{Balanco.ano2.PatrimonioLiquido}}%</span></div>
                                  <!-- ::::::::::::::: -->
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="row">
													<div class="col-12">
														<ul class="box_chart-legenda">
															<li>
																<span class="color"></span>
																<span class="text">Ativo Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Ativo não Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Passivo Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Passivo não Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Patrimônio Líquido</span>
															</li>
														</ul>
													</div>
												</div>
											</div>
										</div>
                    <!-- :::::::::::: -->

                    <!-- ANALISE HORIZONTAL -->
										<div class="col-12 col-lg-12" v-if="verificaValoresVertical(this.solicitacao.Empresa.Balancos)">
											<div class="box box_chart">
												<h2>
                          Análise horizontal
                          <at-popover trigger="hover" placement="right" content="A Análise Horizontal (AH) verifica a evolução de um elemento (Balanço Patrimonial), se baseia na comparação entre resultados de um mesmo indicador em relação a períodos anteriores.">
                            <i class="fas fa-info-circle"></i>
                          </at-popover>
                        </h2>

                        <bar-chart-env :data="DadosGrafico()"/>

												<div class="row">
													<div class="col-12">
														<ul class="box_chart-legenda">
															<li>
																<span class="color"></span>
																<span class="text">Ativo Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Ativo não Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Passivo Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Passivo não Circulante</span>
															</li>
															<li>
																<span class="color"></span>
																<span class="text">Patrimônio Líquido</span>
															</li>
														</ul>
													</div>
												</div>

											</div>
										</div>
                    <!-- ::::::::::::::::: -->

									</div>

                  <!-- DEMONSTRATIVOS FINCANCEIROS -->
									<h4 v-if="this.solicitacao.Empresa.Demonstrativos && Demonstrativos(this.solicitacao).length > 0">Demostrativos financeiros</h4>
									<table class="table table-striped" v-if="Demonstrativos(this.solicitacao).length > 0">
										<thead>
											<tr>
												<th scope="col"></th>
												<th scope="col" v-if="this.solicitacao.Empresa.Mes1 == '' || this.solicitacao.Empresa.Mes1 == undefined">
                          {{this.solicitacao.Empresa.Ano1}}
													<span>{{this.solicitacao.Empresa.PeriodoAnaliseAnterior}}</span>
												</th>
                        <th scope="col" v-else>
                          {{this.solicitacao.Empresa.Mes1}}/{{this.solicitacao.Empresa.Ano1}}
													<span>{{this.solicitacao.Empresa.PeriodoAnaliseAnterior}}</span>
                        </th>

												<th scope="col" v-if="this.solicitacao.Empresa.Mes2 == '' || this.solicitacao.Empresa.Mes2 == undefined">
                          {{this.solicitacao.Empresa.Ano2}}
													<span>{{this.solicitacao.Empresa.PeriodoAnaliseAtual}}</span>
												</th>
                        <th scope="col" v-else>
                          {{this.solicitacao.Empresa.Mes2}}/{{this.solicitacao.Empresa.Ano2}}
													<span>{{this.solicitacao.Empresa.PeriodoAnaliseAtual}}</span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="demo in Demonstrativos(this.solicitacao)">
												<th scope="row">
                         {{demo.Tipo}}
                        </th>
												<td>
                          {{formatDemos(demo.Tipo, demo.ValorAno1, demo.Unidade)}}
                         <!--{{demo.ValorAno1 < 0 ? "-" : ""}}
                         {{!verificaIndice(demo.Tipo) ? "R$" : ""}}
                         {{formatCurrency(demo.ValorAno1)}}
                         {{verificaIndice(demo.Tipo) ? "%" : ""}} -->
                        </td>
												<td>
													<i :class="classIndice(demo)"></i>
                          {{formatDemos(demo.Tipo, demo.ValorAno2, demo.Unidade)}}
                          <!--{{demo.ValorAno2 < 0 ? "-" : ""}}
                          {{!verificaIndice(demo.Tipo) ? "R$" : ""}}
                          {{formatCurrency(demo.ValorAno2)}}
                          {{verificaIndice(demo.Tipo) ? "%" : ""}} -->
                        </td>
											</tr>
										</tbody>
										<tfoot>
											<tr>
												<td colspan="3">
													<p>
														<strong>Observações:</strong> Os valores demonstrados e calculados são baseados nas demonstrações contábeis fornecidas pelo solicitante do empréstimo, sendo essas demonstrações de responsabilidade dos sócios e do contador da empresa.</p>
												</td>
											</tr>
										</tfoot>
									</table>
                  <!-- :::::::::::::::::::: -->

								</section>
							</div>
							<!-- FINAL INDICES FINANCEIROS -->

							<!-- INICIO INDICES COMPLEMENTARES -->
							<div class="tab-pane fade" id="nav-indc" role="tabpanel" aria-labelledby="ind-cont-tab">
								<section class="indices__complementares" v-for="(indices, index) in IndicesComplementares(this.solicitacao)" v-if="indices.Dados">
									<div class="box">
										<h3 class="box--title">{{indices.Grupo}}</h3>
                      <div class="row no-gutters indices__complementares--item" v-for="(indice, i) in indices.Dados">
											<div class="col-12 col-md-4 percentual text-center">
												<h5>{{indice.Tipo}}</h5>
												<ul>
													<li>
														<label v-if="solicitacao.Empresa.Mes1 == '' || solicitacao.Empresa.Mes1 == undefined">{{solicitacao.Empresa.Ano1}}</label>
                            <label v-else>{{solicitacao.Empresa.Mes1}}/{{solicitacao.Empresa.Ano1}}</label>
														<p> {{formatCurrency(indice.ValorAno1)}}</p>
													</li>
													<li>
														<label v-if="solicitacao.Empresa.Mes2 == '' || solicitacao.Empresa.Mes2 == undefined">{{solicitacao.Empresa.Ano2}}</label>
                            <label v-else>{{solicitacao.Empresa.Mes2}}/{{solicitacao.Empresa.Ano2}}</label>
														<p> {{formatCurrency(indice.ValorAno2)}}</p>
													</li>
												</ul>
											</div>
											<div class="col-12 col-md-8 entry">
												<span :class="classBullet(indice.Status)">
													<p class="tolkitBullet" :style="colorBullet(indice.Status)">{{textBullet(indice.Status)}}</p>
												</span>
												<p>{{indice.Descricao}}</p>
											</div>
										</div>
									</div>
								</section>
							</div>
							<!-- FINAL INDICES COMPLEMENTARES -->

              <!-- DADOS DOS SOCIOS E INDICES -->
							<div class="tab-pane fade" id="nav-info" role="tabpanel" aria-labelledby="inf-socios-tab" v-if="this.solicitacao.Empresa.Socios && this.solicitacao.Empresa.Socios.length > 0">
								<section class="indices__socios">
									<div class="box">
										<h3 class="box--title">Capital</h3>
										<hr class="divider">
										<ul class="row no-gutters text-center">
											<li class="col-12 col-md-3">
												<strong>Capital social:</strong> R$ {{capitalSocial}}</li>
											<li class="col-12 col-md-3">
												<strong>Realizado:</strong> R$ {{capitalRealizado}}</li>
											<li class="col-12 col-md-3">
												<strong>Controle:</strong> {{Controle}}</li>
											<li class="col-12 col-md-3">
												<strong>Natureza:</strong> {{Natureza}}</li>
										</ul>
									</div>
									<div class="box">
										<h3 class="box--title">Quadro social</h3>
										<hr class="divider">
										<div class="indices__socios-items">
                      <!-- DADOS DE SOCIOS - ARRAY solicitacao.Empresa.Socio -->
											<div class="indices__socios--item" v-for="socio in this.solicitacao.Empresa.Socios">
												<div class="row no-gutters">
													<div class="col-12 col-md-5 col-lg-4 col-xl-3 text-md-right">
														<p>
															<span>{{socio.Nome}}</span>
															{{socio.TipoSocio}}
														</p>
													</div>
													<div class="col-12 col-md-7 col-lg-8 col-xl-9">
														<p v-if="socio.DataEntrada">
															<strong>Entrada:</strong> {{startDate(socio.DataEntrada)}}</p>
														<p>
															<strong>% Capital Total:</strong> {{socio.ParticipacaoCapital}}</p>
														<p>
															<strong>Observações:</strong> <div v-html="socio.Observacao" class="noBorder"></div>
                            </p>
													</div>
												</div>
											</div>
										</div>
									</div>
								</section>
							</div>
              <!-- :::::::::::::::::::::::::::::: -->

						</div>
						<!-- FINAL CONTEUDO TABS -->

					</div>
					<!-- FINAL BLOCO INDICES -->

          <!-- Bloco para ocultar informacoes -->

          <!-- Investidores com cadastro incompleto ou que nao investiram na oportunidade que ja esta encerrada -->
          <no-data-profile v-else :Msg="this.showMeMsg"></no-data-profile>
          <!-- ::::::::::::::::::::::::::::: -->

          <!-- INICIO STICK BAR -->
					<div class="myDiv">
						<div class="content">
							<div class="d-flex flex-row align-items-center">
								<div class="empresa">
									<h2>{{nomeFantasia}}</h2>
									<span>CNPJ: {{formattedCnpj}}</span>
								</div>
								<div class="rating">
									<span class="circle score"></span>
									<strong>{{score}}</strong>
								</div>
								<div class="info">
									<label>Valor solicitado</label>
									<p>R$ {{valor}}</p>
								</div>
								<div class="info">
									<label>Duração esperada</label>
                  <p v-if="this.solicitacao.PrazoDias > 0">{{this.solicitacao.PrazoDias}} dias</p>
									<p v-else>{{prazo}} meses</p>
								</div>
								<div class="info">
									<label>Retorno CDI</label>
									<p>{{cdi}}%</p>
								</div>
							</div>
							<div class="d-flex mob" style="padding-top: 5px; padding-bottom: 5px;">
								<div class="d-flex" v-if="!this.solicitacao.Encerrado">
									<div class="label">Encerra em:</div>
									<div class="countdown">
										<countdown-custom :end="finishedDate(this.solicitacao.FimCaptacao)"></countdown-custom>
									</div>
								</div>
                <!-- ACOES -->
                <!-- Verifica se o usuario tem o cadastro completo de investidor -->
                <div class="notFinished" v-if="!hasInvestor && !hasSuitability && !isInvestorApproved">
                  <a href="/#/informacoes-adicionais/investidor" class="btn alert-warning">
                    Complete seu cadastro
                  </a>
                </div>
                <!-- :::::::::::::::: -->
                <!-- Varifica se o investimento está encerrado -->
                <div v-if="this.solicitacao.Encerrado" class="finished">
                  <button disabled="disabled" class="btn btn-secondary">Encerrado</button>
                </div>
                <!-- :::::::::::::::::::::: -->
                <!-- Verifica se o investimento já possui todo o valor captado porem nao esta encerrado -->
                <!--<div class="changeValue d-flex" v-else-if="this.validaStatusListaEspera(this.solicitacao) && !(investmentConfirmed) ">
                  <button @click="OpenModalInvestimento(true, 1)" class="btn btn-primary">
                    Lista de Espera
                  </button>
                </div> -->
                <!-- :::::::::::::::::: -->
                <!-- Verifica se o usuario ja possui um investimento cadastrado e quer alterar o valor -->
                <!-- <div class="changeValue d-flex" v-else-if="investmentConfirmed && !solicitacao.GerouBoletos">
                  <button @click="OpenModalInvestimento(true, 1); recalcValues();" class="btn btn-primary">
                    Alterar o valor investido

                  </button>
                </div> -->
                <!-- ::::::::::::::::::: -->
                <!-- Valor no caso de ser o primeiro investimento nesta oportunidade -->
								<form v-on:submit.prevent class="d-flex align-itens-center" v-else-if="hasInvestor && hasSuitability && isInvestorApproved && (investmentReservation == null || investmentReservation.Status == 0) && solicitacao.Valor > solicitacao.ValorCaptado && !this.solicitacao.ChamadaListaEspera">
									<input v-if="this.solicitacao.InvestimentoMaximo <= 0" v-model="investirMenu" type="text" :placeholder="InvestimentoMinimo" v-mask="'money'">

                  <!-- <select v-else v-model="selected" class="form-control form-control-lg">
                    <option value="Selecione um valor">Selecione</option>
                    <option v-for="option in valuesModal" :key="option">
                      {{ option }}
                    </option>
                  </select> -->
                  

                  <at-select v-else class="upper--select" size="large" v-model="selected" placeholder="Selecione">
                      <at-option v-for="option in valuesModal" :key="option" :value="option">{{ option }}</at-option>
                  </at-select>


                  <button v-if="this.InvestidorBloqueado()" class="btn btn-danger" style="cursor: not-allowed;" disabled>Bloqueado</button>
									<button v-if="!this.InvestidorBloqueado()" @click="submitInvestment();" class="btn btn-primary">Investir</button>


								</form>
                <!-- :::::::::::::::::::::::: -->
							</div>
						</div>
					</div>
					<!-- :::::::::::::::: -->

			</div>
			<!-- :::::::::::::: -->

    	</div>

    </div>
    <!-- :::::::::::::::::::: -->

  </div>
</template>

<style lang="scss" scoped>
  @import "../assets/styles/iouu/variables";
  @import "../assets/styles/iouu/mixins";

  .upper--select {
    width: 200px;
    margin-bottom: -1.1em;
  }

  .at-select__selection {
    margin-bottom: 0 !important;
  }

  .noBorder {
    border: none !important;
  }

  .modal-container {
    .modal-header {
      .tit {
        @include font-size(28px);
        margin:0px;
        padding:0px;
        border:none;
      }
    }
  }

  .changeValue {
    &{
      margin-left: 1rem;
      margin-right: 1rem;
    }

    .btn {
      border: #40CD28;
      background: #40CD28;
      text-transform: uppercase;
      font-weight: bold;
      padding: 0px;
      padding-left: 20px;
      padding-right: 20px;
      border-radius: 5px;
      font-size: calcRem(13);
      padding-top: calcRem(10);
      padding-bottom: calcRem(10);
    }
  }

  .notFinished {
    &{
      margin-left: 1rem;
      margin-right: 1rem;
    }
  }

  .finished {
    margin-left: 1rem;
    margin-right: 1rem;

     &.btn-secondary:disabled {
       font-weight: 700 !important;
       text-transform: uppercase !important;
     }
  }

  // infos
  i.fas.fa-info-circle {
    font-size: calcRem(20);
    color: #ccc;
  }

  // Tolkit bullet
  .indices .bullet {
    &:hover {
      p.tolkitBullet {
        opacity: 1;
      }
    }
  }

  .selo-garantia {
    display: flex !important;
    right: 100px;
    height: 80px;
    margin-top: -20px;
    float: right;
	}

  p.tolkitBullet {
    position: absolute;
    left: 28px;
    top: 2px;
    background-color: #fff;
    padding: 1px 20px;
    font-size: 13px !important;
    border-radius: 20px 12px 12px 20px;
    font-weight: 600 !important;
    color: #000;
    opacity: 0;
    width: calcRem(140);
    @include transition(opacity 0.3s ease)
  }

  .carousel-item {
    img {
      border-radius: 5px;
    }
  }

  @include sm {

    .tit_page {

      h1 {
        & {
          font-size: calcRem(30);
        }

        span {
          font-size: 1rem;
        }
      }

      .back {
        display: none;
      }
    }

    .tit {
      h2 {
        font-size: calcRem(20);
      }
    }

    .company-view {
      section {
        h3 {
          font-size: calcRem(20);
        }

        h2 {
          font-size: calcRem(22);
        }

        span {
          font-size: calcRem(18);
        }
      }
    }
  }

  @include xs {

    .tit_page {

      h1 {
        & {
          font-size: calcRem(20);
        }

        span {
          font-size: calcRem(14);
          padding-left: calcRem(10);
          margin-left: calcRem(10);
          line-height: calcRem(45);
          background-size: 6px;
        }
      }

      .back {
        display: none;
      }
    }

    .tit {
      h2 {
        font-size: calcRem(18);
      }

      span {
        font-size: 1rem;
      }
    }

    .company-view {
      section {
        h3 {
          font-size: calcRem(20);
        }

        h2 {
          font-size: calcRem(22);
        }

        span {
          font-size: calcRem(13);
        }
      }
    }

    .box_chart {
      & {
        display: none;
      }
    }
  }
</style>

<script>
	import ApiClient from '../utils/api-client'
	import ApiClientGo from '../utils/api-client-go'
	import * as mutationTypes from '@/store/mutation-types.js'
	import BarChart from '@/components/charts/BarChart'
	import Carousel from '@/components/Carousel'
	import Masker from '@/utils/masker'
	import ArrayHelper from '@/utils/array-helper'
  import InvestmentReservationForm from '@/components/CompanyProfile/InvestmentReservationForm'
  import InvestmentReservationDataModal from '@/components/CompanyProfile/InvestmentReservationDataModal'
  import Countdown from 'vuejs-countdown'
  import countdownCustom from '@/components/countdownCustom'
  import Modal from "@/components/NewModal/Modal"
  import BarChartEnv from '@/components/charts/BarChartAnaliseHorizontal'
  import NoDataProfile from '@/components/NoDataProfile'
  // import Promise from 'promise'

  export default {
    components: {
			BarChart,
			Carousel,
      InvestmentReservationForm,
      InvestmentReservationDataModal,
      Countdown,
      countdownCustom,
      Modal,
      BarChartEnv,
      NoDataProfile
		},
    data() {
      return {
        valuesModal: [],
        selected:"",
        finishedLoading: false,
        boletoPago: false,
        solicitacao: {
          ValorCaptado: null,
          QuantidadeReservasInvestimento: null
        },
        investmentReservation: null,
        googleMapsKey: this.$config.googleApi.googleMapsKey,
        showQueueForm: false,
        minPercentToQueue: this.$config.investment.minPercentToQueue,
        investmentConfirmed: false,
        sDisponivel: 0,
        showModal: false,
        investirMenu: "",
        motivoCancelamento: "",
        nomesGrupos: [],
        balancosZerados: null,
        indexModal: 2,
        preview: false,
        showMeMsg: 1,
        listaEspera: null
      }
    },
    computed: {
      currentUser() {
        return this.$store.state.currentUser
      },
      hasInvestor() {
        return this.currentUser.hasinvestor
      },
      hasSuitability() {
        return this.currentUser.hassuitability
      },
      isInvestorApproved() {
        return this.hasInvestor && (this.currentUser.investor != null && this.currentUser.investor.Status == 'APROVADO')
      },
      id: function () {
        return this.ajustIdOportunidade(this.solicitacao.IdOportunidade, 5)
      },
      company: function () {
        return this.solicitacao.Empresa;
      },
      nomeFantasia: function () {
        return this.company && this.company.NomeFantasia;
      },
      prazo: function () {
				return this.solicitacao.Prazo;
			},
			valor: function () {
				return this.formatCurrency(this.solicitacao.Valor);
			},
			cdi: function () {
				return parseInt(this.solicitacao.Cdi);
			},
      razaoSocial: function () {
        return this.company && this.company.RazaoSocial
      },
      formattedCnpj: function () {
        return Masker.maskCnpj(this.solicitacao.Documento)
      },
      loanType: function () {
        return this.solicitacao.TipoEmprestimo
      },
      scoreClass: function () {
        if (!this.solicitacao.Score) return ""
        return "rating-" + this.solicitacao.Score.replace(/\d/, '').toLowerCase()
      },
      score: function () {
        return this.solicitacao.Score
      },
      companyDescription: function () {
        return this.company && this.company.InformacaoInstitucional
      },
      telefoneComercial: function () {
        var v = this.solicitacao.TelefoneComercial;
        v = v.replace(/\D/g,"");
        
        if(v.length == 11)
          v = v.replace(/(\d\d)(\d)(\d\d\d\d)(\d\d\d\d)/, "($1) $2 $3-$4");
        else
          v = v.replace(/(\d\d)(\d\d\d\d)(\d\d\d\d)/, "($1) $2-$3");
        return v
      },
      dataFundacao: function () {
        return (this.company && this.company.DataFundacao) ? this.company.DataFundacao.toLocaleDateString('pt-BR') : ""
      },
      quantidadeEmpregados: function () {
        return this.company && this.company.QuantidadeEmpregados
      },
      nomeGrupoEconomico: function () {
        if (!this.company) return null
        return this.company.NomeGrupoEconomico != "" ? this.company.NomeGrupoEconomico :
          'Não pertence a nenhum grupo econômico'
      },
      address: function () {
        if (!this.company || this.company.Endereco === undefined)  return null
        const address = this.company.Endereco
        const complement = this.company.Endereco.Complemento && this.company.Endereco.Complemento.length > 0 ? " - " +
          this.company.Endereco.Complemento : ""
        return `${address.Logradouro}, ${address.Numero}${complement}, ${address.Bairro} - ${address.Cep}, ${address.Cidade}/${address.Uf}`
      },
      motivoSolicitacao: function () {
        return this.solicitacao.Motivo
      },
      garantiasOferecidas: function () {

        return this.solicitacao.TipoGarantia != "" ? this.solicitacao.TipoGarantia :
          "Não possui nenhum tipo de garantia"
      },
      faturamentoAnual: function () {
        if (!this.solicitacao) return null
        return this.formatCurrency(this.solicitacao.Faturamento)
      },
      lucroLiquido: function () {
        if (!this.company) return null
        return this.formatCurrency(this.company.LucroMensal)
      },
      divida: function () {
        return this.company.ValorDividaBancaria != 0 || this.company.ValorDividaBancaria != null ? "R$ " + this.formatCurrency(
          this.company.ValorDividaBancaria) : "Nada consta"
      },
      dataConsultaEndividamento() {
        const date = this.company.DataConsultaEndividamentoTotal ? this.company.DataConsultaEndividamentoTotal : this.company.DataConsultaEndividamento

       if (date !== undefined && date !== null && date !== ""){
          if (typeof date === "string") {
            let split = date.split("T")
            let dataString = split[0].split("-")

            return `${dataString[1]} / ${dataString[0]}`
          } else {
            return date !== undefined ? `${(date.getMonth()+1).toString().padStart(2, "0")}/${date.getFullYear()}` : ""
          }
        } else {
          return ""
        }
      },
      analiseEmpresa() {
        return this.solicitacao.AnaliseEmpresa
      },
      nomeSolicitante() {
        return this.solicitacao.Solicitante.NomeCompleto
      },
      chartData() {
        if(!this.company.FaturamentoDozeMeses) {
          return null
        } else {
          return this.company.FaturamentoDozeMeses.map(item => {
            return {
              label: item.Mes.slice(0, 3) + "/" + item.Ano.toString().slice(2, 4),
              value: item.Valor
            }
          })
        }
      },
      site() {
        return this.company.Site
      },
      mapUrl() {
        return `https://www.google.com/maps/embed/v1/place?key=${this.googleMapsKey}&q=${this.address}`
      },
      porteEmpresa() {
        return this.solicitacao.Empresa.Porte ? this.solicitacao.Empresa.Porte : "Outros";
      },
      Balanco() {
        if(this.solicitacao.Empresa.Balancos !== undefined && this.solicitacao.Empresa.Balancos.length > 0) {

          var balanco = this.solicitacao.Empresa.Balancos.filter((array) => {
             if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" ||
             array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
               return array
             }
          })

          //console.log(balanco.length)

          if(balanco.length >= 5) {
            var valores = {
                "ano1": {
                  "AtivoCirculante": balanco[0].AVAno1 !== undefined ? balanco[0].AVAno1 : 0.00,
                  "AtivoNCirculante": balanco[1].AVAno1 !== undefined ? balanco[1].AVAno1 : 0.00,
                  "PassivoCirculante": balanco[2].AVAno1 !== undefined ? balanco[2].AVAno1 : 0.00,
                  "PassivoNCirculante": balanco[3].AVAno1 !== undefined ? balanco[3].AVAno1 : 0.00,
                  "PatrimonioLiquido": balanco[4].AVAno1 !== undefined ? balanco[4].AVAno1 : 0.00,
                },
                "ano2": {
                  "AtivoCirculante": balanco[0].AVAno2 !== undefined ? balanco[0].AVAno2 : 0.00,
                  "AtivoNCirculante": balanco[1].AVAno2 !== undefined ? balanco[1].AVAno2 : 0.00,
                  "PassivoCirculante": balanco[2].AVAno2 !== undefined ? balanco[2].AVAno2 : 0.00,
                  "PassivoNCirculante": balanco[3].AVAno2 !== undefined ? balanco[3].AVAno2 : 0.00,
                  "PatrimonioLiquido": balanco[4].AVAno2 !== undefined ? balanco[4].AVAno2 : 0.00,
                }
              }
            }
          }



        // console.log("Balancos: ", balanco)
        // console.log("Valores: ", valores)

        return (this.solicitacao.Empresa.Balancos && balanco.length >= 5) ? valores : null
      },
      companyFacebook() {
        return this.solicitacao.Empresa.Facebook
      },
      companyTwitter() {
        return this.solicitacao.Empresa.Twitter
      },
      companyLinkedin() {
        return this.solicitacao.Empresa.Linkedin
      },
      companyInstagram() {
        return this.solicitacao.Empresa.Instagram
      },
      companyVimeo() {
        return this.solicitacao.Empresa.Vimeo
      },
      formatoInvestimento() {
        return this.solicitacao.FormatoInvestimento
      },
      negativacoes() {
        return this.solicitacao.Empresa.Negativacoes || "Nada consta"
      },
      atrasos() {
        return this.formatCurrency(this.solicitacao.Empresa.Atrasos) || "0,00"
      },
      pictures() {
        return this.solicitacao.Empresa.Imagens
      },
      vimeoVideoUrl() {
        return this.solicitacao.Empresa.VimeoVideoUrl
      },
      capitalSocial() {
        //console.log(this.solicitacao.Empresa.CapitalSocial);
        return this.solicitacao.Empresa.CapitalSocial ? this.formatCurrency(this.solicitacao.Empresa.CapitalSocial) : 0.0
      },
      capitalRealizado() {
        return this.formatCurrency(+this.solicitacao.Empresa.CapitalRealizado) || 0.0
      },
      Natureza() {
        return this.solicitacao.Empresa.Natureza || "Nada consta"
      },
      Controle() {
        return this.solicitacao.Empresa.Controle || "Nada consta"
      },
      Setor() {
        return this.solicitacao.Empresa.SetorEmpresa || "Nada consta"
      },
      PontuacaoSetor() {
        return this.solicitacao.Empresa.PontuacaoSetor >= 0 ? this.solicitacao.Empresa.PontuacaoSetor : ""
      },
      InadimplenciaSetor() {
        return this.solicitacao.Empresa.ProbabilidadeMediaInadimplencia >= 0 ? this.solicitacao.Empresa.ProbabilidadeMediaInadimplencia : ""
      },
      InvestimentoMinimo() {
        return (this.solicitacao.InvestimentoMinimo && this.solicitacao.InvestimentoMinimo) > 0 ? this.formatCurrency(this.solicitacao.InvestimentoMinimo) : this.formatCurrency(1000)
      }
    },
    methods: {
      submitInvestment(valor = null) {
        if(valor){
          this.selected = valor
          // ajuste emergencial css
          document.querySelector('.main-content').style.zIndex = 10
          this.showModal = true
        }else if(
          this.selected ||
          this.investmentReservation ||
          this.solicitacao.ChamadaListaEspera ||
          this.solicitacao.Valor == this.solicitacao.ValorCaptado
        ){
          // ajuste emergencial css
          document.querySelector('.main-content').style.zIndex = 10
          this.showModal = true
        }else{
          // this.$Notify.error('Valor de investimento inválido')
          this.showModal = true
        }
      },
      async voltar(alterou = null) {
        // ajuste emergencial css
        alterou ? window.location.reload() : this.showModal = false
        document.querySelector('.main-content').style.zIndex = 2
      },
      formatarTipoEmprestimo(tipoEmprestimo) {
        if (tipoEmprestimo.toLowerCase() == "emprestimo-de-impacto2") {
          return "Impacto";
        }

        var splitedTipoEmprestimo = tipoEmprestimo.split('-');

        if (splitedTipoEmprestimo.length > 1) {
          return splitedTipoEmprestimo[1][0].toUpperCase() + splitedTipoEmprestimo[1].substr(1);
        }

        return tipoEmprestimo[0].toUpperCase() + tipoEmprestimo.substr(1);
      },
      Demonstrativos(solicitacao) {
        let demonstrativos = []

        if(solicitacao.Empresa.Demonstrativos && solicitacao.Empresa.Demonstrativos.length > 0) {
            demonstrativos = solicitacao.Empresa.Demonstrativos.filter( function(elem, i, array) {
              return elem.AdicionarPerfil
            })
        }

        //console.log("demo: ", demonstrativos)

        return demonstrativos

      },
      ajustIdOportunidade(id, qtd) {
        var s = String(id);
        while (s.length < (qtd || 2)) {
          s = "0" + s;
        }
        return s;
      },
      formatCurrency(value) {
        if (value == null || value == undefined)
          return parseFloat(0).toLocaleString('pt-BR', {
            minimumFractionDigits: "2",
            maximumFractionDigits: 2
          })

        return value.toLocaleString('pt-BR', {
          minimumFractionDigits: "2",
          maximumFractionDigits: 2
        })
      },
      formatDemos(tipo, valor, unidade) {
          let val;
          let label = this.verificaIndice(tipo);

          if(unidade !== undefined && unidade !== null && unidade !== "") {
            val = this.formatCurrency(valor)
            if(unidade === "%" || unidade === "x") {
              return val + "" + unidade
            } else {
              if(valor < 0) {
                val = valor * (-1)
                return "- " + unidade + " " + this.formatCurrency(val)
              } else {
                val = this.formatCurrency(valor)
                return unidade + " " + this.formatCurrency(val)
              }
            }
          } else {
            if(label === "%") {
              val = this.formatCurrency(valor)
              return  val + "" + label
            } else {
              if(valor < 0) {
                val = valor * (-1)
                return "- " + label + " " + this.formatCurrency(val)
              } else {
                val = this.formatCurrency(valor)
                return label + " " + this.formatCurrency(val)
              }
          }
          }
      },
      finishedDate(date) {
        if(date) {
          let year = date.getFullYear()
          let day = date.getDate();
          let month = date.getMonth();
          let monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October",
            "November", "December"
          ]
          let endDate = monthArray[month] + " " + day.toString() + ", " + year.toString();
          	return endDate;
        } else {
          return null
        }

			},
      diffDate(d1, d2) {
        var miliSecs = 0

        if (d1 == "")
          miliSecs = (new Date(d2)) - (new Date())
        else
          miliSecs = (new Date(d2)) - (new Date(d1))

        const diffDays = Number.parseInt(miliSecs / 1000 / 60 / 60 / 24)

        if (diffDays < 0) return "encerrado";
        if (diffDays == 0) return "hoje";

        return diffDays + " dias";
      },
      startDate(date) {
        let spliter = date.split("T")

        spliter = spliter[0].split("-")

        //console.log(spliter)

        return spliter[1] + "/" + spliter[0];
      },
      validaStatusListaEspera(item) {
        let time = item.FimCaptacao.getTime();
        
        var resultDt = this.diffDate("",  new Date(item.FimCaptacao.getTime()+86400000));

				if (resultDt.toUpperCase() !== "ENCERRADO" && item.StatusAnalise !== "ENCERRADO" && item.ValorCaptado >= item.Valor)
					return true;

				return false;
      },
      blockHight(percent) {
        return `height: ${percent}%;`
      },
      DadosGrafico() {
         let Dados = [];
         // Indices do gráfico
         let labels = ["Ativo Circulante", "Ativo não Circulante", "Passivo Circulante", "Passivo não Circulante", "Patrimônio Líquido"]
         // Cores do gráfico
         let cores = ['#2980b9', '#e67e22', '#c0392b', '#27ae60', '#f1c40f']
         // Valores da solicitacao
         let balancos = this.solicitacao.Empresa.Balancos.filter((array) => {
           if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" ||
             array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
               return array
             }
         })

          if(this.solicitacao.Empresa.Balancos && balancos.length > 0) {
             for (let i = 0; i < 5; i++) {
               Dados.push({label: labels[i],value: balancos[i].AH, color: cores[i], percent: balancos[i].AH});
             }
          }

          //console.log(Dados)

          return Dados;
      },
      verificaIndice(tipo) {
        // Verifica se possui % para setar o tipo de valor que sera mostrado
        // R$ ou %
        if(tipo.indexOf("%") != -1) {
            return "%"
        } else {
          return "R$"
        }
      },
      classIndice(demo) {
        // Verifica a seta do demonstrativo do ano 2
        // Se ocorreu um acréscimo ou decrescimo

        if(demo.Classificacao == undefined) {
          if(demo.ValorAno1 > demo.ValorAno2) {
            return "fas fa-caret-down"
          } else if (demo.ValorAno1 < demo.ValorAno2) {
            return "fas fa-caret-up"
          } else {
            return ""
          }
        }

        else {
          if(demo.Classificacao == "Negativo") {
            return "fas fa-caret-down"
          } else if (demo.Classificacao == "Positivo") {
            return "fas fa-caret-up"
          } else {
            return ""
          }
        }
      },
      IndicesComplementares(solicitacao) {

        // Verifica se possui o array de indices complementares
        let indices = solicitacao.Empresa.IndicesFinanceiros ? solicitacao.Empresa.IndicesFinanceiros : [];
        // array dos nomes dos grupos deo indices
        let nomeGrupos = [];
        // array informacoes dos grupos complementares indexadas

        // indice auxiliar
        let contador = 0;

        // popula o array com grupos com todos os nome dos grupos
        for (let indice in indices) {
          nomeGrupos.push(indices[indice].Grupo);
        }

        // filtra o array de grupos eliminando nomes repetidos
        nomeGrupos = nomeGrupos.filter(function(i, elem, array) {
          return array.indexOf(i) === elem;
        })

        // pegas os nomes dos grupos para poder renderizar nos blocos
        //this.nomesGrupos = Object.assign({},grupos);

        // monta o array de grupo com indice dos nomes dos grupos e dentro os arrays das informacoes relavantes do indices
        let grupo  = new Array(nomeGrupos.length)

        for(let i = 0 ;i < nomeGrupos.length ; i++)
        {
          grupo[i] = {};
          grupo[i].Grupo = nomeGrupos[i];

          for(let j=0; j < indices.length ; j++)
          {
            if(indices[j].AdicionarPerfil && nomeGrupos[i] == indices[j].Grupo)
            {

              if(grupo[i].Dados === undefined){
                grupo[i].Dados = [];
              }

              grupo[i].Dados.push({
                    "Tipo": indices[j].Tipo,
                    "ValorAno1": indices[j].ValorAno1,
                    "ValorAno2": indices[j].ValorAno2,
                    "Descricao": indices[j].Descricao,
                    "Status": indices[j].Status,
                    "AdicionarPerfil": indices[j].AdicionarPerfil
                })
            }
          }

        }

        //console.log("=================")
        //console.log("grupo: ", grupo.length);
        //console.log("grp ", grupo);

       return grupo;
      },
      classBullet(status) {
        // Classes das bullets de cada um dos status do indice
        // Verde - success
        // Amarelo - alert
        // Vermelho - warning
         switch(status) {
            case "Verde":
              return "bullet bullet-success"

            case "Amarelo":
               return "bullet bullet-alert"

            case "Vermelho":
               return "bullet bullet-warning"

            default:
               return "bullet bullet-secondary"
         }
      },
      colorBullet(status) {
        // Classes das bullets de cada um dos status do indice
        // Verde - success
        // Amarelo - alert
        // Vermelho - warning
         switch(status) {
            case "Verde":
              return "background-color: #00DFC1"

            case "Amarelo":
               return "background-color: #FFD858; width: 80px;"

            case "Vermelho":
               return "background-color: #FF5C5F"

            default:
               return "background-color: #fff"
         }
      },
      textBullet(status) {
        // Classes das bullets de cada um dos status do indice
        // Verde - success
        // Amarelo - alert
        // Vermelho - warning
         switch(status) {
            case "Verde":
              return "Índice Positivo"

            case "Amarelo":
               return "Alerta"

            case "Vermelho":
               return "Índice Negativo"
         }
      },
      verificaValoresVertical(balanco) {
        if(balanco && balanco.length > 0){
          var counter = 0;

          let b = balanco.filter((array) => {
            if (array.Tipo === "Ativo Circulante" || array.Tipo === "Ativo Não Circulante" || array.Tipo === "Passivo Circulante" ||
             array.Tipo === "Passivo Não Circulante" || array.Tipo === "Patrimônio Líquido") {
               return array
             }
          })

          if (b.length < 5) {
            return false
          }

          for(var i in b) {
            if(b[i].AVAno1 <= 0 && b[i].AVAno2 <= 0) {
              counter++
            }
          }

          if(counter > 4) {
            return false
          } else {
            return true
          }
        }

        return false;
      },
      verificaValoresIndices(indices) {
        var counter = 0;

        if(indices && indices.length > 0) {
          for(let i = 0; i < indices.length; i++) {
            if(indices[i].AdicionarPerfil !== true && indices[i].ValorAno1 <= 0 && indices[i].ValorAno2 <= 0) {
              counter++
            }
          }

          if(counter > 20) {
            return false;
          } else {
            return true;
          }
        }

        return false;
      },
      InvestidorBloqueado() {

        if(this.currentUser.investor== null ||  this.currentUser.investor.Bloqueio == null  ||this.currentUser.investor.Bloqueio.FimBloqueio == null)
            return false;
            
          var  FimBloqueio= new Date(this.currentUser.investor.Bloqueio.FimBloqueio)
          
          return (FimBloqueio > (new Date()));
			},
      voltarLink(){
        var separador = window.location.href.split("#")
        if(separador.length > 2)
        {
          return "#"+ separador[2];
        }

        return ""
      },
      validacaoSetor(empresa) {

        if(empresa && empresa.SetorEmpresa && empresa.PontuacaoSetor >= 0 && empresa.ProbabilidadeMediaInadimplencia >= 0) {
          return true
        }

        return false;
      },
      showMeInfo() {
         // Verifica se o investidor tem acesso as informações detalhadas da empresa ou nao
         // Verifica cadastro completo
         let token = this.$route.params.id.substring(0, 5)

         let d = new Date()
         let y = d.getFullYear()

         if(this.$route.query.preview === `adminiouu${token}${y}`) {
           return true
         }

         if(this.hasInvestor && this.hasSuitability && this.currentUser.investor.Status == "APROVADO") {
            // Verifica status da oportunidade
            if(this.solicitacao.Encerrado) {
                // Verifica se o investidor tem investimento na oportunidade
                if(this.investmentConfirmed) {
                  return true
                } else {
                  return false
                }

            } else {
              return true
            }

         } else {
           this.showMeMsg = 2
           return false
         }
      },
      recalcValues() {
        console.log("Entrou em recalcular valores")
        this.valuesModal = [];

        let valorSelect = 0;
        let valorRestante = this.solicitacao.Valor - this.solicitacao.ValorCaptado;
        let quantidade = (this.solicitacao.InvestimentoMaximo / this.solicitacao.InvestimentoMinimo);

			
				for(let i=1; i <= quantidade; i++) {
					this.valuesModal.push("R$ " + (this.solicitacao.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
        }
        
      },

      //tagueamento GA
      taggingGA() {
        this.$ga.page({
          page: '/oportunidades/perfil-empresa/:id',
          title: 'Empresa novo',
        })
      },
    },
    beforeCreate() {
      this.$store.dispatch('updateUser')
    },
    async created() {
      try {
        document.querySelector('.main-content').style.zIndex = 2
      }catch(e){
        console.log(e)
      }
       // BLOQUEIO ...
       if(this.$store.state.currentUser.investor) {
         if(typeof this.$store.state.currentUser.investor.Bloqueio !== 'undefined'){
           window.location.href = "#/";
         } 
       }

      // MODAL ...
      if(document.getElementsByTagName("main").length > 0) {
        document.getElementsByTagName("main")[0].style.zIndex = "2";
      }

      try {
          // VALIDAÇÃO DA RESERVA DE INVESTIMENTO ...
          this.investmentReservation = await ApiClient.getInvestmentReservation({
            loanRequestId: this.$route.params.id
          })

          // VERIFICA SOLICITACAO ...
          // /solicitacaoes/detalhes/:id
          this.solicitacao = await ApiClientGo.getLoanRequest(this.$route.params.id);

          this.solicitacao._id = this.$route.params.id;
          this.solicitacao.ChamadaListaEspera ? this.solicitacao.ValorCaptado = this.solicitacao.Valor : ''

          if(this.investmentReservation !== null) {
            this.investmentConfirmed = true;
              
            if(this.investmentReservation.StatusBoleto === "paid") {
              this.boletoPago = true;
            }
          }

          this.solicitacao.Encerrado = this.solicitacao.StatusAnalise == "ENCERRADO" || this.diffDate("", new Date(this.solicitacao.FimCaptacao.getTime())) == "encerrado";

          this.valuesModal = [];
          let valorSelect = 0;
          let valorRestante = this.solicitacao.Valor - (this.solicitacao.ValorCaptado == undefined ? 0 : this.solicitacao.ValorCaptado)
          let quantidade = (this.solicitacao.InvestimentoMaximo / this.solicitacao.InvestimentoMinimo);
          valorRestante == 0 ? this.listaEspera = true : ''

          for(let i=1; (i <= quantidade && valorRestante > valorSelect ) ; i++) {
            this.valuesModal.push("R$ " + (this.solicitacao.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
            valorSelect = this.solicitacao.InvestimentoMinimo * i;
          }

          if(this.investmentConfirmed) {
            for(let i=1; i <= quantidade; i++) {
              this.valuesModal.push("R$ " + (this.solicitacao.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
            }
          }

        this.finishedLoading = true;
        this.$store.commit(mutationTypes.STOP_LOADING);
      } catch(erro) {
        console.log(erro)
        this.finishedLoading = true;
        this.$store.commit(mutationTypes.STOP_LOADING);
      }

      //tagueamento GA
      await this.taggingGA();
    },
    /*created() {
      this.solicitacaoId = this.$route.params.id;

      if(this.$store.state.currentUser.investor != null){
        if(typeof this.$store.state.currentUser.investor.Bloqueio != 'undefined')
          window.location.href="#/"
      }
    
      //ajuste modal
      if (document.getElementsByTagName("main").length > 0)
        document.getElementsByTagName("main")[0].style.zIndex = "0";

      ApiClient.getInvestmentReservation({
          loanRequestId: this.solicitacaoId
        })
        .then(investmentReservation => {
          this.investmentReservation = investmentReservation;
          if (investmentReservation != null)
            this.investmentConfirmed = true;

          ApiClient.getMyAvalibleMoney()
            .then(item => {

              item.data.credito = (item.data.credito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
              var credito = parseFloat(item.data.credito);

              item.data.debito = (item.data.debito).toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
              var debito = parseFloat(item.data.debito);

              this.sDisponivel = credito - debito;
              this.sDisponivel = parseFloat(this.sDisponivel.toFixed(2));

              if (this.sDisponivel < 0.01) {
                this.sDisponivel = 0;
              }

              if (this.investmentReservation != null && this.investmentReservation.ReInvestimento > 0) {
                this.sDisponivel += this.investmentReservation.ReInvestimento
              }

            });




        })

      var x = ApiClient.getLoanRequest(this.solicitacaoId)
        .then(loanRequest => {
          this.solicitacao = loanRequest;

          //console.log("solicitacao: ", this.solicitacao);
          
          loanRequest.Encerrado = loanRequest.StatusAnalise == "ENCERRADO" || this.diffDate("", new Date(loanRequest.FimCaptacao.getTime())) =="encerrado";

          this.solicitacao = loanRequest;

          this.valuesModal = [];
          let valorSelect = 0;
          let valorRestante = loanRequest.Valor - loanRequest.ValorCaptado;
          let quantidade = (loanRequest.InvestimentoMaximo / loanRequest.InvestimentoMinimo);

          for(let i=1; (i <= quantidade && valorRestante > valorSelect ) ; i++) {
            this.valuesModal.push("R$ " + (loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
            valorSelect = loanRequest.InvestimentoMinimo * i;
          }

          if(this.investmentConfirmed) {
            for(let i=1; i <= quantidade; i++) {
              this.valuesModal.push("R$ " + (loanRequest.InvestimentoMinimo * i).toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) );
            }
          }
          //console.log("loan: ", loanRequest)
        })

      x.then(() => {
        this.finishedLoading = true
        this.$store.commit(mutationTypes.STOP_LOADING)

      }).catch(() => {
        this.finishedLoading = true
        this.$store.commit(mutationTypes.STOP_LOADING)
      });
    }, */
  }
</script>



// WEBPACK FOOTER //
// src/views/CompanyProfile.vue